<div routerLink="/scanner/scan">
  <image-loader-utils url="scanner-qr-re" extraClasses="icon-svg"></image-loader-utils>
</div>

<div *ngIf="this.couponDetailList && this.couponDetailList.length > 0; then thenBlock; else elseBlock"></div>
<ng-template #thenBlock class="cashout-main">
  <ng-container *ngIf="this.couponDetailList[0].SlipState === 'Open' && isInfoOpen">
    <div class="notification info-box">
      <div class="text-container">
        <image-loader-utils url="info-circle" extraClasses="scanner-info-circle"></image-loader-utils>
        <p>
          {{ 'Cashout_Info' | translate }}
        </p>
      </div>

      <div class="scanner-button">
        <div (click)="this.infoCloser()">
          {{ 'OK' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
  <div class="headerDecs">
    <h2>{{ 'betting_slip_details' | translate }}</h2>
  </div>
  <div class="cashout-slip-item">
    <div class="slip-top-area">
      <div class="slip-top-left-area">
        <div class="slip-combine">
          <p>{{ this.couponDetailList[0].SlipType }}</p>
          <div class="slip-live" *ngIf="this.isLive">
            <p>{{ 'LIVE' | translate }}</p>
          </div>
        </div>
      </div>
      <div class="slip-top-right-area">
        <div>
          <div class="slip-top-pw">
            <p>
              Status: <span class="slip-top-right-m">{{ this.couponDetailList[0].SlipState }}</span>
            </p>
          </div>
          <div class="slip-top-skate">
            <p>
              {{ 'scanner.ticket.stake' | translate }}:<span class="slip-top-right-m">{{ this.couponDetailList[0].Amount }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="slip-center-area">
      <ng-container *ngIf="slipDetailList && slipDetailList.length > 0">
        <div class="match-item-container" *ngFor="let matchItem of slipDetailList; trackBy: trackBySlipId" (click)="goEventDetail(matchItem.BetradarMatchId)">
          <div class="match-top">
            <div class="odd-name">
              <div *ngIf="matchItem.Banko === 1" class="match-top-banko"><p>B</p></div>
              <p class="odd-name-p">{{ matchItem.OddsType }} {{ matchItem.SpecialBetValue }} ({{ matchItem.Outcomes }})</p>
            </div>
            <div class="match-odd">
              <p>{{ matchItem.OddValue }}</p>
              <p *ngIf="matchItem.StateId === 3" class="math-won-status">{{ 'CASHOUT.WON' | translate }}</p>
              <p *ngIf="matchItem.StateId === 4" class="math-lost-status">{{ 'CASHOUT.LOST' | translate }}</p>
              <p *ngIf="matchItem.StateId === 2" class="math-lost-status">{{ 'CASHOUT.CANCELED' | translate }}</p>
            </div>
          </div>
          <div class="match-bottom">
            <div class="match-description">
              <div class="match-description-column-one">
                <p>{{ matchItem.EventName }}</p>
              </div>
              <div *ngIf="matchItem.BetTypeId === 1" class="match-description-column-two">
                <p>Score {{ matchItem.HomeTeamScore }}:{{ matchItem.AwayTeamScore }}</p>
              </div>
            </div>
            <div *ngIf="matchItem.BetTypeId === 1" class="match-score-and-minute">
              <p>{{ matchItem.HomeTeamScore }}:{{ matchItem.AwayTeamScore }}</p>
              <p class="match-minute">{{ matchItem.MatchStatus }}</p>
            </div>
            <div *ngIf="!(matchItem.MatchStatus && matchItem.MatchStatus !== '')" class="match-score-and-minute pre">
              <p>{{ matchItem.EventDateIso | dateFormat : 'dd.MM.yy' }}</p>
              <p>{{ matchItem.EventDateIso | dateFormat : 'HH:mm' }}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="this.couponDetailList[0].SlipState === 'Open'">
    <div class="cashout-button-box" *ngIf="cashoutItem">
      <div class="cashout-submit-message" *ngIf="cashoutItem.cashoutSubmitMessageIsActive">
        {{ 'cashout_submit_message' | translate }}
      </div>

      <ng-container *ngIf="cashoutApproveSlipId != cashoutItem.SlipId">
        <div
          class="cashout-value-button"
          *ngIf="(isJacktimeActive ? cashoutItem.CashOutValueJacktime : (cashoutItem.CashOutValue | cashoutBalance)) > 0"
          (click)="cashoutApprove(cashoutItem.SlipId)">
          Cashout &nbsp;<span [ngClass]="{ cashoutInitial: cashoutItem.State == 0, cashoutgoUp: cashoutItem.State == 1, cashoutgoDown: cashoutItem.State == 2 }">{{
            isJacktimeActive ? (cashoutItem.CashOutValueJacktime | balanceFormat) : (cashoutItem.CashOutValue | balanceFormat)
          }}</span>
        </div>
      </ng-container>
      <ng-container *ngIf="cashoutApproveSlipId == cashoutItem.SlipId">
        <div class="cashout-approve-box">
          <div
            class="cashout-value-button confirm"
            *ngIf="(isJacktimeActive ? cashoutItem.CashOutValueJacktime : (cashoutItem.CashOutValue | cashoutBalance)) !== 0"
            (click)="cashOut(cashoutItem.SlipId, isJacktimeActive ? cashoutItem.CashOutValueJacktime : cashoutItem.CashOutValue)">
            {{ 'Confirm' | translate }}
          </div>

          <div
            class="cashout-value-button modify"
            *ngIf="(isJacktimeActive ? cashoutItem.CashOutValueJacktime : (cashoutItem.CashOutValue | cashoutBalance)) !== 0"
            (click)="cashoutModify()">
            {{ 'cancel' | translate }}
          </div>
        </div>
      </ng-container>
      <div class="cashout-value-button lock" *ngIf="(isJacktimeActive ? cashoutItem.CashOutValueJacktime : (cashoutItem.CashOutValue | cashoutBalance)) === 0">
        <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
      </div>
    </div>
  </ng-container>
</ng-template>
<ng-template #thenBlock class="slipId-container">
  <p class="cashout-createdDate">Created Date: {{ this.couponDetailList[0].CreateDateISO | dateFormat : 'dd.MM.yy HH:mm' }}</p>
  <p class="cashout-slipID" (click)="goEventDetail(this.couponDetailList[0].SlipId)">#{{ this.couponDetailList[0].SlipId }}</p>
</ng-template>
<ng-template #elseBlock>
  <ng-container *ngIf="!this.couponDetailList">
    <div class="loading-gif">
      <div class="loading-spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="this.couponDetailList">
    <div class="headerDecs">
      <h2>{{ 'betting_slip_details' | translate }}</h2>
    </div>
    <div class="notification error-box">
      <p>
        {{ 'SCANNER_TICKET.NOT_FOUND' | translate }}
      </p>
      <div class="action-buttons">
        <div class="buttonAction" [routerLink]="'/scanner/scan'">{{ 'SCANNER_TICKET.GO_Back' | translate }} ⟳</div>
        <div class="buttonAction" [routerLink]="'/home'">{{ 'SCANNER_TICKET.GO_Homepage' | translate }} ↑</div>
      </div>
    </div>
  </ng-container>
</ng-template>
